import { Card } from "@mui/material";

interface Props {
  children: JSX.Element | string;
  type?: 'default' | 'green' | 'red';
  disableBackground?: boolean;
};

function WeenectCard({
  children,
  type,
  disableBackground = false,
}: Props) {
  return (
    <Card className={`card ${type} ${disableBackground && 'disable-background'}`}>
      {children}
    </Card>
  );
}

export default WeenectCard;